import { StockItem } from '@kinet-open-network/client/stock-items/data-access';
import { IStockItemIngredient } from '@kinet-open-network/shared/data-access/model-pbgas';
import { Type } from 'class-transformer';

export class AppStockItem extends StockItem {
  prototypeCode?: string;
  serialNumberDevice?: string;
  partnerExtId?: string;
  @Type(() => Date)
  pressureTestExpirationDate?: Date;
  @Type(() => Date)
  pressureTestDate?: Date;
  owner?: string;
  manufacturer?: string;
  shortName?: string;
  @Type(() => Number)
  bottleWeight?: number;
  @Type(() => Number)
  gasWeight?: number;
  @Type(() => Date)
  manufactureDate?: Date;
  @Type(() => Boolean)
  isFull?: boolean;
  @Type(() => Boolean)
  specialWarranty?: boolean;
  reservationPartner?: string;
  @Type(() => Number)
  itemOrder?: number;
  nsCode?: string;
  @Type(() => Number)
  type?: number;
  iaCode2?: string;
  adrUnNumber?: string;
  adrText?: string;
  adrSafetyTagNumber?: string;
  adrRestrictiveTunnelCode?: string;
  @Type(() => Number)
  adrBottleContent?: number;
  @Type(() => Number)
  adrTransportCategoryFullBottles?: number;
  @Type(() => Number)
  adrTransportCategoryEmptyBottles?: number;
  @Type(() => Number)
  adrHazardPoints?: number;
  composition?: IStockItemIngredient[];
  gasFeeItemSku?: string;
  @Type(() => Boolean)
  box?: boolean;
  @Type(() => Boolean)
  publicPageEnabled?: boolean;
  @Type(() => Boolean)
  includeInRentalInvoice?: boolean;
  @Type(() => Date)
  lastFillDate?: Date;
  lastFilledBy?: string;
}
